import { useStyles } from "@/components/SectionTitle/SectionTitle.styles"
import React from "react"

interface SectionTitleProps {
    title: string
    description?: string
    isCentered?: boolean
    isSubtitle?: boolean
}

export const SectionTitle = ({ title, description, isCentered = false, isSubtitle = false }: SectionTitleProps) => {
    const { classes } = useStyles({ isCentered, isSubtitle })
    return (
        <div className={classes.container}>
            <div className={classes.title}>{title}</div>
            {description && <div className={classes.description}>{description}</div>}
        </div>
    )
}
